module.exports = __webpack_public_path__ + "static/media/avive_aed_accepted_default.8e2b91a7.svg";